"use client";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// import "../../../assets/css/UserManagement.min.css";

export default function UserManagementSection ({ searchQuery = "" }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://leapatinternational.com/admin/api/v1/user.php");
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        setData(result.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleAddUser = () => {
    navigate("/dashboard/add-user");
  };

  const handleEditUser = (user) => {
    navigate(`/dashboard/edit-user/${user.id}`);
  };

  const handleDeleteUser = async (userId) => {
    if (!window.confirm("Are you sure you want to delete this user?")) {
      return;
    }

    try {
      setDeleteLoading(userId);

      const data = new FormData();
      data.append("id", userId);

      const response = await fetch("https://leapatinternational.com/admin/api/v1/delete_user.php", {
        method: "POST",
        body: data,
      });

      const result = await response.json();

      if (result.status === "success") {
        setData((prev) => prev.filter((user) => user.id !== userId));
        toast.success("User deleted successfully!");
      } else {
        toast.error(result.message || "Failed to delete user");
      }
    } catch (err) {
      console.error("Error:", err);
      toast.error("Network error. Please try again.");
    } finally {
      setDeleteLoading(null);
    }
  };

  // Calculate stats from data
  const stats = {
    total: data.length,
    active: data.filter((u) => u.status === "Active").length,
    inactive: data.filter((u) => u.status === "Inactive").length,
    recentUsers: data.filter((u) => {
      const userDate = new Date(u.created_date);
      const weekAgo = new Date();
      weekAgo.setDate(weekAgo.getDate() - 7);
      return userDate >= weekAgo;
    }).length,
  };

  if (loading) {
    return (
      <div className="user-management-section">
        <div className="loading-spinner">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="user-management-section">
        <div className="alert alert-danger" role="alert">
          Error: {error}
        </div>
      </div>
    );
  }

  return (
    <div className="category-management-section">
      {/* Page Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h1 className="page-title">User Management</h1>
              <p className="page-subtitle">Manage system users and their information</p>
            </div>
            <button className="add-button" onClick={handleAddUser}>
              <i className="bi bi-plus-lg icon-white" style={{ color: 'white', marginRight: '5px' }}></i> Add User
            </button>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      {/* <div className="row mb-4">
        <div className="col-lg-3 col-md-6 mb-3">
          <div className="card stat-card">
            <div className="card-body">
              <div className="stat-content">
                <div className="stat-icon">👥</div>
                <div className="stat-details">
                  <h3 className="stat-value">{stats.total}</h3>
                  <p className="stat-title">Total Users</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6 mb-3">
          <div className="card stat-card">
            <div className="card-body">
              <div className="stat-content">
                <div className="stat-icon">✅</div>
                <div className="stat-details">
                  <h3 className="stat-value">{stats.active}</h3>
                  <p className="stat-title">Active Users</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6 mb-3">
          <div className="card stat-card">
            <div className="card-body">
              <div className="stat-content">
                <div className="stat-icon">🆕</div>
                <div className="stat-details">
                  <h3 className="stat-value">{stats.recentUsers}</h3>
                  <p className="stat-title">New This Week</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6 mb-3">
          <div className="card stat-card">
            <div className="card-body">
              <div className="stat-content">
                <div className="stat-icon">❌</div>
                <div className="stat-details">
                  <h3 className="stat-value">{stats.inactive}</h3>
                  <p className="stat-title">Inactive Users</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Users Table */}
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Users List</h5>
            </div>
            <div className="card-body">
              {data.length > 0 ? (
                <div className="content-table">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th style={{ width: '15%' }}>Username</th>
                          <th style={{ width: '15%' }}>Email</th>
                          <th style={{ width: '15%' }}>Mobile No</th>
                          <th style={{ width: '15%' }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((user) => (
                          <tr key={user.id}>
                            <td style={{ width: '15%' }}>
                              <div className="user-info">
                                <span className="user-name">{user.username}</span>
                              </div>
                            </td>
                            <td style={{ width: '15%' }}>
                              <span className="user-email">{user.email}</span>
                            </td>
                            <td style={{ width: '15%' }}>
                              <span className="user-mobile">{user.mobile_no}</span>
                            </td>
                            <td style={{ width: '15%' }}>
                              <div className="action-buttons">
                                <button
                                  className="btn btn-sm btn-outline-primary"
                                  title="Edit"
                                  onClick={() => handleEditUser(user)}
                                >
                                  ✏️
                                </button>
                                <button
                                  className="btn btn-sm btn-outline-danger"
                                  title="Delete"
                                  onClick={() => handleDeleteUser(user.id)}
                                  disabled={deleteLoading === user.id}
                                >
                                  {deleteLoading === user.id ? (
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  ) : (
                                    "🗑️"
                                  )}
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="text-center py-5">
                  <div className="empty-state">
                    <div className="empty-icon">👥</div>
                    <h5>No users found</h5>
                    <p className="text-muted">
                      {searchQuery ? `No users match "${searchQuery}"` : "Start by adding your first user"}
                    </p>
                    {!searchQuery && (
                      <button className="btn btn-primary" onClick={handleAddUser}>
                        <i className="bi bi-plus-lg icon-white" style={{ color: 'white', marginRight: '5px' }}></i> Add First User
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
